import { post} from "../utils";

export default host => (id, {
  titleColor,
  titleSize,
  titleFont,
  containerTitleColor,
  containerTitleColorHover,
  containerTitleSize,
  containerDescriptionColor,
  containerDescriptionColorHover,
  containerDescriptionSize,
  liveButtonColor,
  liveButtonIcon,
  liveButtonShape,
  textFont,
  favIcon,
  interactionColor,
  elementBackground,
  showMoreButton,
  mainFont
}) => {
  return post(`${host}/channels/${id}/preferences`, makeJsonDataPreferences(
     titleColor,
     titleSize,
     titleFont,
     containerTitleColor,
     containerTitleColorHover,
     containerTitleSize,
     containerDescriptionColor,
     containerDescriptionColorHover,
     containerDescriptionSize,
     liveButtonColor,
     liveButtonIcon,
     liveButtonShape,
     textFont,
     favIcon,
     interactionColor,
     elementBackground,
     showMoreButton,
      mainFont
    ))
    .then(response => response.json())
    .then(response => response.data)
}

const makeJsonDataPreferences = (
  titleColor,
  titleSize,
  titleFont,
  containerTitleColor,
  containerTitleColorHover,
  containerTitleSize,
  containerDescriptionColor,
  containerDescriptionColorHover,
  containerDescriptionSize,
  liveButtonColor,
  liveButtonIcon,
  liveButtonShape,
  textFont,
  favIcon,
  interactionColor,
  elementBackground,
  showMoreButton,
  mainFont
) => {
  let object = {};

  object.title_color = titleColor;
  object.title_size = titleSize;
  object.title_font = titleFont;
  object.container_title_color = containerTitleColor;
  object.container_title_color_hover = containerTitleColorHover;
  object.container_title_size = containerTitleSize;
  object.container_description_color = containerDescriptionColor;
  object.container_description_color_hover = containerDescriptionColorHover;
  object.container_description_size = containerDescriptionSize;
  object.live_button_color = liveButtonColor;
  object.live_button_icon = liveButtonIcon;
  object.live_button_shape = liveButtonShape;
  object.text_font = textFont;
  object.fav_icon = favIcon;
  object.interaction_color = interactionColor;
  object.element_background = elementBackground;
  object.show_more_button = showMoreButton;
  object.main_font = mainFont;
  object._method = "PUT"

  return JSON.stringify(object)
}
